export function articleSlider() {
    let $sliders = $(".article-slider");

    $sliders.each( function () {
        let slider = $(this);

        slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            infinite: true,
            speed: 500,
            autoplay: true,
            focusOnSelect: true,
            autoplaySpeed: 5000,
            pauseOnHover: false,
            pauseOnDotsHover: false,
            pauseOnFocus: false,
            prevArrow: `<button type="button" class="slick-prev slick-arrow">
                            <svg width="26" height="22" viewBox="0 0 26 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M26 11H2M2 11L12.5 1M2 11L12.5 21" stroke="white" stroke-width="1.5"/>
                            </svg>
                        </button>`,
            nextArrow: `<button type="button" class="slick-next slick-arrow">
                            <svg width="26" height="22" viewBox="0 0 26 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M26 11H2M2 11L12.5 1M2 11L12.5 21" stroke="white" stroke-width="1.5"/>
                            </svg>
                        </button>`,
        });
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/articleSlider.js